import styled from 'styled-components';

const PageStyle = styled.div`
  .header-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 14px;
  }
  .content {
    /* height: calc(100vh - 160px); */
    border: 1px solid #0c3255;
    border-radius: 5px;
    padding: 10px;
  }

  .box-action {
    display: flex;
    justify-content: flex-end;
  }
`;

export default PageStyle;
